import { rgb, degrees } from "pdf-lib";

export const col = (h) => {
    const s = (h || "#ef4444").replace("#", "");
    return rgb(parseInt(s.slice(0, 2), 16) / 255 || 0, parseInt(s.slice(2, 4), 16) / 255 || 0, parseInt(s.slice(4, 6), 16) / 255 || 0);
};
export const colArr = (h) => { const c = col(h); return [c.red, c.green, c.blue]; };

// Maps viewport coords (scale 1, y-down, rotation applied) to PDF user space.
export function pageMapper(page) {
    const b = page.getCropBox();
    const rot = (((page.getRotation().angle || 0) % 360) + 360) % 360;
    const Wv = rot % 180 ? b.height : b.width, Hv = rot % 180 ? b.width : b.height;
    const map = ([px, py]) => {
        const fx = px / Wv, fy = py / Hv;
        if (rot === 90) return [b.x + fy * b.width, b.y + fx * b.height];
        if (rot === 180) return [b.x + (1 - fx) * b.width, b.y + fy * b.height];
        if (rot === 270) return [b.x + (1 - fy) * b.width, b.y + (1 - fx) * b.height];
        return [b.x + fx * b.width, b.y + (1 - fy) * b.height];
    };
    return { Wv, Hv, map, box: b };
}

export const toPath = (pts, map, close) => pts.map((p, i) => { const [x, y] = map(p); return `${i ? "L" : "M"} ${x} ${-y}`; }).join(" ") + (close ? " Z" : "");

const FONT_FILES = { sans: "LiberationSans", serif: "LiberationSerif", mono: "LiberationMono", calibri: "Carlito", roboto: "Roboto", opensans: "OpenSans" };
export function makeFonts(pdf) {
    const cache = {};
    return {
        get(family = "sans", b = false, i = false) {
            const v = b && i ? "BoldItalic" : b ? "Bold" : i ? "Italic" : "Regular";
            const key = `${FONT_FILES[family] || FONT_FILES.sans}-${v}`;
            if (!cache[key]) cache[key] = fetch(`/fonts/${key}.ttf`).then((r) => r.arrayBuffer()).then((ab) => pdf.embedFont(ab, { subset: true }));
            return cache[key];
        },
    };
}

// Draw text with baseline start P and direction point Q (both viewport coords); handles page rotation.
export function drawTextT(target, text, P, Q, map, opts) {
    const [px, py] = map(P), [qx, qy] = map(Q);
    const ang = (Math.atan2(qy - py, qx - px) * 180) / Math.PI;
    target.drawText(text, { ...opts, x: px, y: py, rotate: degrees(ang) });
}

export function wrap(text, font, size, maxW) {
    const out = [];
    String(text || "").split("\n").forEach((para) => {
        let line = "";
        para.split(" ").forEach((w) => {
            const tryL = line ? `${line} ${w}` : w;
            if (font.widthOfTextAtSize(tryL, size) > maxW && line) { out.push(line); line = w; } else line = tryL;
        });
        out.push(line);
    });
    return out;
}

export const bboxOfPts = (pts, pad = 0) => {
    const xs = pts.map((p) => p[0]), ys = pts.map((p) => p[1]);
    return [Math.min(...xs) - pad, Math.min(...ys) - pad, Math.max(...xs) + pad, Math.max(...ys) + pad];
};
